/*
QUICKFIX: Toggles visibility of the billing company field when clicking on its label
https://jira.angrycreative.se/browse/RP-219
This addresses an issue in qala-theme prior to v4.0.1 where the company field's
click handler was nested inside the coupon handling logic in qala-theme/src/javascript/components/checkout.js. If there were no
coupon options on the checkout page (when .checkout-toggle-section was missing),
the billing company field couldn't be toggled by click and users couldn't fill it.
This implementation makes sure that the billing company field can be toggled
regardless of coupon functionality, while checking for existing handlers to
prevent duplicate functionality once the theme is updated and the issue is fixed.
*/
jQuery( document ).ready( function( $ ) {
	const isCheckout = document.querySelector( '.woocommerce-checkout' );

	if ( ! isCheckout ) {
		return;
	}
	const $billingCompanyLabel = $( '#billing_company_field > label' );
	if ( $billingCompanyLabel.length === 0 ) {
		return;
	}
	// Check if element already has click handlers
	const hasClickHandlers = $._data( $billingCompanyLabel[ 0 ], 'events' );
	if ( ! hasClickHandlers || ! hasClickHandlers.click ) {
		$billingCompanyLabel.on( 'click', function() {
			const $billingCompanyInput = $( 'input#billing_company' );
			if ( ! $billingCompanyInput ) {
				return;
			}

			$billingCompanyInput.toggle();
		} );
	}
} );
